import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import About from '../views/About.vue'
import FAQ from '../views/FAQ.vue'
import A5 from '../views/products/A5.vue'
import M0 from '../views/products/M0.vue'
import M1 from '../views/products/M1.vue'
import M3 from '../views/products/M3.vue'
import News from '../views/News.vue'
import NewsDetail from '../views/NewsDetail.vue'

import FIBO from '../views/FIBO.vue'
import Error from '../views/Error.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    component: About
  },
  {
    path: '/contact',
    name: 'Contact',
    beforeEnter() {
        window.location.href = '/contact.html'
    }
  },
  {
    path: '/faq',
    name: 'FAQ',
    component: FAQ
  },
  {
    path: '/a5',
    name: 'A5',
    component: A5
  },
  {
    path: '/m0',
    name: 'M0',
    component: M0
  },
  {
    path: '/m1',
    name: 'M1',
    component: M1
  },
  {
    path: '/m3',
    name: 'M3',
    component: M3
  },

  {
    path: '/news',
    name: 'News',
    component: News
  },
  {
    path: '/news/:id',
    name: 'NewsDetail',
    component: NewsDetail
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    beforeEnter() {
      window.location.href = '/privacy_policy.html'
    }
  },
  {
    path: '/refund-policy',
    name: 'RefundPolicy',
    beforeEnter() {
      window.location.href = '/refund_policy.html'
    }
  },
  {
    path: '/shipping-policy',
    name: 'ShippingPolicy',
    beforeEnter() {
      window.location.href = '/shipping_policy.html'
    }
  },
  {
    path: '/terms-of-service',
    name: 'TermsOfService',
    beforeEnter() {
      window.location.href = '/terms_of_service.html'
    }
  },
  {
    path: '/fibo',
    name: 'FIBO',
    component: FIBO
  },
  {
    path: '/app-privacy-policy',
    name: 'AppPrivacyPolicy',
    beforeEnter() {
      window.location.href = '/app_privacy_policy.html'
    }
  },
  {
    path: '/form',
    name: 'Form',
    beforeEnter() {
      window.location.href = '/form.html'
    }
  },
  {
    path: '/error',
    name: 'Error',
    component: Error
  },
  {
    path: '/loading',
    name: 'Loading',
    component: () => import('../components/Loading.vue')
  },
  {
    path: '/50x',
    name: 'Error50x',
    component: Error
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    // 始终滚动到顶部
    return { top: 0 }
  }
})

// 全局路由守卫 - 确保页面标题正确更新
router.beforeEach((to, from, next) => {
  // 根据路由名称设置页面标题
  const titleMap = {
    'Home': 'ANOVATOR | Smart Body Composition Analyzer',
    'About': 'About Us - Anovator',
    'FAQ': 'FAQ - Anovator',
    'A5': 'A5 - Anovator',
    'M0': 'M0 - Anovator',
    'M1': 'M1 - Anovator',
    'M3': 'M3 - Anovator',
    'FIBO': 'FIBO - ANOVATOR',
    'AppPrivacyPolicy': 'App Privacy Policy - ANOVATOR',
    'Form': 'Contact Form - ANOVATOR',
    'Error': 'Error - anovator | smart body composition analyzer',
    'Error50x': 'Error - anovator | smart body composition analyzer',
    'Loading': 'Loading - ANOVATOR',
    'News': 'News - ANOVATOR'
  }
  
  // 设置页面标题
  const title = titleMap[to.name] || 'ANOVATOR | Smart Body Composition Analyzer'
  document.title = title
  
  next()
})

export default router